module.exports = __webpack_public_path__ + "img/p0.0f46bea2.png";